import React from "react";
import Svg, { Polygon, Rect } from "react-native-svg";

type Props = {
  size?: number;
  color?: string;
};

export default function YouTubeSvgIcon({
  size = 18,
  color = "#111827",
}: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Rect x="3" y="6" width="18" height="12" rx="3.2" fill={color} />
      <Polygon points="10,9 16,12 10,15" fill="#ffffff" />
    </Svg>
  );
}
